<template>
    <div class="panel-card">
        <div class="panel-header">
            <div class="panel-title">便捷功能</div>
        </div>
        <div class="panel-body">
            <div class="func-grid">
                <a-row>
                    <a-col :span="6" v-for="item in filteredList" :key="item.id">
                        <div class="item" @click="route(item.path)">
                            <img :src="item.imagePath" alt="系统图标" />
                            <div>{{ item.title }}</div>
                        </div>
                    </a-col>

<!--                    <a-col :span="6">-->
<!--                        <div class="item" @click="route('/chatgpt')">-->
<!--                            <img src="/openai.png" alt="系统图标" />-->
<!--                            <div>{{ "GPT 3.5 Turbo" }}</div>-->
<!--                        </div>-->
<!--                    </a-col>-->
                </a-row>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'QuickFunctions',
    data() {
        return {
            showDialog: false,
            list: [
                {
                    title: "会议申请",
                    imagePath: '/index/calendar.png',
                    path: "/oa/meeting/add",
                },

                {
                    title: "开票申请",
                    imagePath: '/index/bookmark.png',
                    path: "/finance/invoice/apply",
                },


                {
                    title: "礼品申领",
                    imagePath: '/index/rewards.png',
                    path: "/oa/gift/apply",
                },

                {
                    title: "我的考勤",
                    imagePath: '/index/CreateTicket.png',
                    path: "/human-resources/clock",
                },

                {
                    title: "通讯录",
                    imagePath:'/index/profile.png',
                    path: "/address-list",
                },

                {
                    title: "群众来信公示",
                    imagePath: require("@/assets/icon4.png"),
                    path: "/party/letter",
                },

                {
                    title: "部门协作",
                    imagePath: '/index/team.png',
                    path: "/collaborate",
                },

                {
                    title: "工单申请",
                    imagePath: '/index/InitiateMeeting.png',
                    path: "/oa/workOrder/add",
                    skipPermission: true, // 表单页不在菜单表中，跳过菜单权限过滤
                },
                {
                    title: "协同设计(新)",
                    imagePath: '/index/edit.png',
                    path: "https://portal.njszy.com/cosys/#/dashboard",
                },
                // {
                //   title: "酒水申领",
                //   imagePath: require("@/assets/icon14.png"),
                //   path: "/oa/material/apply",
                // },
                // {
                //   title: "物资采购申请",
                //   imagePath: require("@/assets/icon14.png"),
                //   path: "/oa/purchaseMaterials/apply",
                // },
                // {
                //   title: "固定资产申请",
                //   imagePath: require("@/assets/icon14.png"),
                //   path: "/oa/fixedAssets/apply",
                // },
                // {
                //   title: "IT固定资产报废",
                //   imagePath: require("@/assets/icon14.png"),
                //   path: "/oa/fixedAssets/scrap/0",
                // },
                // {
                //   title: "固定资产报废",
                //   imagePath: require("@/assets/icon14.png"),
                //   path: "/oa/fixedAssets/scrap/1",
                // },
                // {
                //   title: "固定资产处置",
                //   imagePath: require("@/assets/icon14.png"),
                //   path: "/oa/fixedAssets/handleScrap",
                // },
            ],
        };
    },

    computed: {
        filteredList() {
            return this.list.filter(
                (item) => item.skipPermission || !item.path || item.path.startsWith('http') || this.$getPermission(item.path)
            );
        },
    },

    methods: {
        route(path) {
            if (!path) {
                this.$message.error("开发中，敬请期待！");
                return;
            }
            if (/^https?:\/\//.test(path)) {
                window.open(path, "_blank");
            } else {
                this.$router.push(path);
            }
        },
    },
};
</script>

<style lang="less" scoped>
.panel-card {
    background: #fff;
    border: 1px solid #eef0f3;
    border-radius: 12px;
}
.panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 16px;
    border-bottom: 1px solid #f0f0f0;
}
.panel-title {
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
    padding-left: 12px;
    /* border-left: 4px solid #2563eb; 删掉原来的border-left */
    position: relative;
}
.panel-title::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 16px; /* 控制竖线高度，按需修改 */
    background-color: #2563eb;
}
.panel-body {
    padding: 4px 18px;
}

.item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    border-radius: 4px;
    color: #333;
    font-size: 12px;
    white-space: nowrap;
    cursor: pointer;

    &:hover {
        background-color: #f9f9f9;
    }

    img {
        height: 30px;
        margin-bottom: 4px;
    }

    > div {
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>